// jQuery
window.$ = window.jQuery = require('jquery');

// Foundation
require('foundation-sites/dist/js/foundation');
$(document).foundation();

require('@fortawesome/fontawesome-free');

// axios
window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

window.secondsToTime = s => {
    const date = new Date(0);
    date.setSeconds(s);
    return date.toISOString().substr(11, 8);
};

window.timeToSeconds = t => {
    var p = str.split(':'),
        s = 0, m = 1;
    while (p.length > 0) {
        s += m * parseInt(p.pop(), 10);
        m *= 60;
    }
    return s;
};

window.trans = (s, replacements)  => s;

window.lang = () => {
    const parts = window.location.pathname.split('/');
    if (parts[0]) {
        return parts[0];
    } else {
        return 'en';
    }
};

window.debounce = (func, delay) => {
    let inDebounce;
    return function() {
        const context = this;
        const args = arguments;
        clearTimeout(inDebounce);
        inDebounce = setTimeout(() => func.apply(context, args), delay);
    }
};

// mousetrap
let Mousetrap = require('mousetrap');
require('mousetrap/plugins/global-bind/mousetrap-global-bind');
require('mousetrap/plugins/pause/mousetrap-pause');

// limit for pagination
(function () {
    document.querySelectorAll('.per-page [type=submit]').forEach(el => el.style.display = 'none');
    document.addEventListener('change', e => {
        if (!e.target.closest('.per-page')) {
            return;
        }
        e.target.closest('form').submit();
    });
})();

// direction for pagination
(function () {
    document.querySelectorAll('.sort-by [type=submit]').forEach(el => el.style.display = 'none');
    document.addEventListener('change', e => {
        if (!e.target.closest('.sort-by')) {
            return;
        }
        e.target.closest('form').submit();
    });
})();

// focus search
(function () {

    Mousetrap.bind('control+shift+f', function() {
        focusSearch();
    });
    function focusSearch() {
        const videoTextSearchEl = document.querySelector('[data-tabs-content=video-tabs] .is-active [type=search]');
        if (videoTextSearchEl) {
            videoTextSearchEl.focus();
        }
    }

})();

(function () {

    const el = document.querySelector('.keyboard-shortcuts');
    if (!el) {
        return;
    }
    el.addEventListener('click', e => {
        const $modal = $('#' + e.target.dataset.open);
        e.preventDefault();
        $.ajax(e.target.href)
            .done(resp => {
                $modal.find('.reveal-content').html(resp)
                $modal.foundation('open');
            });
    });

})();

import LogRocket from 'logrocket';
window.LogRocket = LogRocket;
LogRocket.init('95tsae/videotext');
